export default __webpack_public_path__ + "img/ad8a070564aba44a331e6b07a39a60e0.png";